import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, sendPasswordResetEmail, confirmPasswordReset, reauthenticateWithCredential, getIdToken } from 'firebase/auth';
class AuthAPI {
    constructor() {
        Object.defineProperty(this, "$auth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Sign Up new user using email and password
        Object.defineProperty(this, "signUp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (email, password) => createUserWithEmailAndPassword(this.$auth, email, password)
        });
        // Sign in user using email and password
        Object.defineProperty(this, "signIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (email, password) => signInWithEmailAndPassword(this.$auth, email, password)
        });
        // Sign out user
        Object.defineProperty(this, "signOut", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => signOut(this.$auth)
        });
        // Reset user password and send link to the email
        Object.defineProperty(this, "resetPassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (email) => sendPasswordResetEmail(this.$auth, email)
        });
        // Create new password from reset password form
        Object.defineProperty(this, "createNewPassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (code, newPassword) => confirmPasswordReset(this.$auth, code, newPassword)
        });
        // Authenticate user using his credentials
        // and retrieve all user's data back
        Object.defineProperty(this, "authenticate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (credentials) => reauthenticateWithCredential(this.$auth.currentUser, credentials)
        });
        // Sometimes when user hanging on the website for too long and doing nothing
        // we need to update JWT token manually. This is what this method do.
        //
        // forceUpdate flag set to true can force firebase to update JWT event if token not expired yet.
        // e.g when user switches dealer JWT token needs to be update manually.
        Object.defineProperty(this, "updateToken", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (forceUpdate) => getIdToken(this.$auth.currentUser, forceUpdate)
        });
        this.$auth = getAuth();
    }
}
export default new AuthAPI();
